import { render, staticRenderFns } from "./PhraseListItem.vue?vue&type=template&id=115d5c3f&scoped=true"
import script from "./PhraseListItem.vue?vue&type=script&lang=js"
export * from "./PhraseListItem.vue?vue&type=script&lang=js"
import style0 from "./PhraseListItem.vue?vue&type=style&index=0&id=115d5c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115d5c3f",
  null
  
)

export default component.exports